import { combineReducers } from 'redux';
import { createReducer } from '../utils';
import { fetchBrands, fetchLocations } from './actions';

export default combineReducers({
    brands: createReducer([], {
        [fetchBrands]: (state, action) => action.payload,
    }),
    countries: createReducer([], {
        [fetchLocations]: (state, action) => action.payload,
    }),
});
